"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prepareArguments;

var _index = require("../index");

function prepareArguments(arg, depth) {
  try {
    return JSON.stringify((0, _index.decycle)(arg, depth));
  } catch (error) {
    return error.toString(); // IE still cyclic.
  }
}